import { CSSResultArray } from 'lit';
import style from './mc-textarea.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/textarea/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [style, tokens];
